<template>
  <div id="select-occasion" class="mt-2">
    <b-overlay :show="loader" rounded="sm">
      <div class="container mb-3 ">
        <center>
          <h3 for="">
            <strong class="text-danger my-3"></strong>SELECT PRICE RANGE
          </h3>
          <span
            v-if="button"
            class="pet-select-price-range-error-text text-danger"
            >*Please select a price range</span
          >
        </center>
        <label class="wrap my-5 col-md-12">
          <select
            name=""
            class="form-control noBorder"
            id=""
            v-model="selected_price"
          >
            <option value="">Select Price</option>
            <option :value="price" v-for="price in priceranges"
              >${{ price.from_price }} To ${{ price.to_price }}</option
            >
          </select>
        </label>
        <div class="mt-3 mb-3" slot="modal-footer">
          <div class="row d-flex justify-content-between">
            <div class="col-md-4">
              <button class="btn btn-warning col-md-6" @click="prev">
                Previous
              </button>
            </div>
            <div class="col-md-4 ">
              <button class="btn btn-danger col-md-6 pull-right" @click="next">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <img
            src="@/assets/site/images/Govava_Wait_icon.gif"
            alt=""
            class=""
          />
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "PriceRange",
  props: ["type"],
  data() {
    return {
      priceranges: [],
      selected_price: "",
      button: false,
      menu: null,
      loader: true,
    };
  },
  created() {
    this.getAllPriceRange();
  },
  methods: {
    getAllPriceRange() {
      this.loader = true;
      var menu = this.menu;
      var token = localStorage.getItem("userData");
      var userdata_array = JSON.parse(token);
      var api_token = userdata_array.token;
      var fetch_url =
        process.env.VUE_APP_URL + "customer/pricerange/getAllPriceRange";
      fetch(fetch_url, {
        method: "post",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: "Bearer " + api_token,
        },
        body: JSON.stringify({
          type: this.type,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          if (data.pricerange) {
            this.priceranges = data.pricerange.priceranges;
          } else {
            this.priceranges = data.priceranges;
          }
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    next() {
      if (this.selected_price == "") {
        this.button = true;
      } else {
        this.loader = true;
        this.$emit("priceToproducts", this.selected_price);
      }
    },
    prev() {
      this.selected_price = null;
      this.$emit("priceToPreference", this.selected_price);
    },
  },
};
</script>

<style>
.pet-select-price-range-error-text {
  display: block;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 500;
}
</style>
